'use client';
/**
 * 시군구 배너(·홈 배너) 빈 자리 — 오픈 기념 쿠폰 배너(E안 3:1). 유료 시군구 배너(PaidAdRotator 의 pad-item)와
 * 같은 구조·클래스(pad pad-rot › pad-item › pad__head · pad__card › pad__media--wide · pad__body)를 그대로 써서
 * 폭·모서리·안쪽 여백·간격·그림 상자가 유료 광고와 똑같다. 그림 비율 상자 + minHeight 로 자리 높이를 미리 잡는다(CLS 0).
 * 유료 광고 계측(data-paid-ad-root · data-ad-campaign) 없음 — 클릭은 advertise_click(promo_district|promo_home).
 */
import AdvertiseMiniLink from '@/components/ads/acq/AdvertiseMiniLink';
import { trackAdvertiseClick } from '@/components/ads/acq/track';
import { PROMO_DISTRICT_COPY as C, promoSlotHref, type PromoSlotFrom } from '@/lib/ads/promo-slot';
import PromoPicture from './PromoPicture';
import '@/components/ads/paid/paid-ads.css';

export interface PromoDistrictSlotProps {
  placement: 'district' | 'home';
  /** 머리줄 작은 「광고하기」 출처(유료 광고 머리줄과 같은 값 — ad_district_site · ad_district_blog …) */
  miniFrom?: string;
  minHeight?: number;
}

export default function PromoDistrictSlot({ placement, miniFrom = 'ad_district', minHeight = 0 }: PromoDistrictSlotProps) {
  const from: PromoSlotFrom = placement === 'home' ? 'promo_home' : 'promo_district';
  return (
    <div className="pad pad-rot" data-nosnippet="" data-ad-promo={placement} style={minHeight > 0 ? { minHeight } : undefined}>
      <div className="pad-item" data-on="1">
        <div className="pad__head">
          <span className="pad__chip">광고</span>
          {placement === 'district' ? <span className="pad__name">{C.name}</span> : null}
          <AdvertiseMiniLink from={miniFrom} />
        </div>
        <a className="pad__card" href={promoSlotHref(from)} rel="nofollow" data-ad-promo-link={from} onClick={() => trackAdvertiseClick(from)}>
          <div className="pad__media pad__media--wide">
            <PromoPicture kind="banner31" />
          </div>
          <span className="pad__body">
            <span className="pad__chip">{C.chip}</span>
            <span className="pad__txt">
              <span className="pad__hl">{C.head}</span>
              <span className="pad__intro">{C.intro}</span>
            </span>
            <span className="pad__btn">{C.cta}</span>
          </span>
        </a>
      </div>
    </div>
  );
}
